import { Link } from "react-router-dom";
import { ACCENT, NAVY } from "@/lib/siteTheme";
import logo from "@/assets/design/blue-heron-logo.webp";

const linkClass = "no-underline text-[15px] font-medium hover:text-[#E8A33D] transition-colors";
const linkStyle = { color: "rgba(247,243,236,0.8)" };

const SiteFooter = () => (
  <footer className="px-6 md:px-14 pt-20 pb-8" style={{ background: NAVY, fontFamily: "'Archivo', sans-serif" }}>
    <div
      className="max-w-[1280px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1.2fr] gap-12 pb-14"
      style={{ borderBottom: "1px solid rgba(247,243,236,0.1)" }}
    >
      <div>
        <Link to="/">
          <img src={logo} alt="Blue Heron" width={448} height={80} className="h-7 w-auto block brightness-0 invert opacity-95 mb-[18px]" />
        </Link>
        <p className="max-w-[260px] text-[15px] leading-relaxed" style={{ color: "rgba(247,243,236,0.55)" }}>
          Marketing for local businesses, built in Kansas City.
        </p>
      </div>
      <div>
        <div className="font-bold text-xs tracking-[0.1em] uppercase mb-[18px]" style={{ color: "rgba(247,243,236,0.45)" }}>
          Quick Links
        </div>
        <div className="flex flex-col gap-3">
          <Link to="/" className={linkClass} style={linkStyle}>Home</Link>
          <Link to="/about" className={linkClass} style={linkStyle}>About</Link>
          <Link to="/case-studies" className={linkClass} style={linkStyle}>Case Studies</Link>
          <Link to="/reviews" className={linkClass} style={linkStyle}>Reviews</Link>
        </div>
      </div>
      <div>
        <div className="font-bold text-xs tracking-[0.1em] uppercase mb-[18px]" style={{ color: "rgba(247,243,236,0.45)" }}>
          Services
        </div>
        <div className="flex flex-col gap-3">
          <Link to="/plans#websites" className={linkClass} style={linkStyle}>Websites</Link>
          <Link to="/case-studies#seo" className={linkClass} style={linkStyle}>Local SEO</Link>
          <Link to="/case-studies#ads" className={linkClass} style={linkStyle}>Google Ads</Link>
        </div>
      </div>
      <div>
        <div className="font-bold text-xs tracking-[0.1em] uppercase mb-[18px]" style={{ color: "rgba(247,243,236,0.45)" }}>
          Contact
        </div>
        <div className="flex flex-col gap-3">
          <span className="text-[15px] font-medium" style={linkStyle}>Kansas City Area</span>
          <a href="tel:+18163704263" className={linkClass} style={linkStyle}>(816) 370-4263</a>
          <Link
            to="/book"
            className="inline-flex w-fit items-center font-extrabold text-[13px] px-5 py-2.5 rounded-full no-underline mt-1"
            style={{ background: ACCENT, color: NAVY }}
          >
            Book A Call
          </Link>
        </div>
      </div>
    </div>
    <div className="max-w-[1280px] mx-auto flex flex-wrap gap-4 justify-between items-center pt-6">
      <span className="text-[13px]" style={{ color: "rgba(247,243,236,0.45)" }}>© {new Date().getFullYear()} Blue Heron</span>
      <div className="flex gap-6">
        <Link to="/terms" className="no-underline text-[13px] hover:text-[#E8A33D] transition-colors" style={{ color: "rgba(247,243,236,0.45)" }}>
          Terms of Service
        </Link>
        <Link to="/privacy" className="no-underline text-[13px] hover:text-[#E8A33D] transition-colors" style={{ color: "rgba(247,243,236,0.45)" }}>
          Privacy Policy
        </Link>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
